import React from 'react';

const Info = () => (
  <h2>Payment Info</h2>
);

export default Info;
